import { createListPage, createDetailPage } from 'pages/common'
import { api, actionCreators } from 'store/modules/districts'
import Content from './grid'
import Form from './form'

import { urls } from 'urls'

const PAGE = 'districts'

export const metadata = {
  icon: 'flag',
  page: PAGE,
  isSoftDelete: false,
  urls: urls[PAGE]
}

const DistrictsListPage = createListPage({ metadata, api, actionCreators, Content })
const DistrictsDetailPage = createDetailPage({ metadata, actionCreators, Form })

export { DistrictsListPage, DistrictsDetailPage }
